import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SideBar } from './components/sideBar';
import AtualizarPlanilhas from './pages/Eap/atualizarPlanilhas';
import CPU from './pages/Eap/cpu';
import Insumos from './pages/Eap/insumos';
import NovoProjeto from './pages/Eap/newProject';
import Table from './pages/Eap/table';
import { loginRequest } from './authConfig';
import InsumosPage from './pages/Eap/insumosPage';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import Moedas from './pages/Eap/moedas';
import React from 'react';
import Refresh from './pages/Eap/refresh';

export default function AppRouter() {

  function Login() {
    const { instance } = useMsal();
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  }

  return (
    <BrowserRouter>
      <UnauthenticatedTemplate>
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <SideBar />
        <Routes>
          <Route path="/eap/:id" element={<Table />} />
          <Route path="/insumos" element={<InsumosPage />} />
          <Route path="/eap/:id/:cpu" element={<CPU />} />
          <Route path='eap/:id/:cpu/insumo' element={<Insumos />} />
          <Route path='update' element={<AtualizarPlanilhas />} />
          <Route path='/moedas' element={<Moedas />} />
          <Route path='/refresh' element={<Refresh />} />
          <Route path='/' element={<NovoProjeto />} />
        </Routes>
      </AuthenticatedTemplate>
    </BrowserRouter>
  )
}
